<template>
<div class="page-wrapper creat-bill">
  <div>
    <h3 class="title">基本信息</h3>
    <div>
      <div class="inline-b mr8 mb16">
        <span class="label">项目名称：</span>
        <Select v-model="contractInfo.projectId" class="item-width" @on-change="changeProject">
          <Option v-for="item in projectsList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </div>
      <div class="inline-b mr8 mb16">
        <span class="label">房间号：</span>
        <Select
          class="item-width remote"
          :disabled = "!contractInfo.projectId"
          v-model="contractInfo.roomId"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="remoteLoading"
          placeholder="请输入想查询的房间号"
          @on-change="changeRoomId"
          >
            <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </div>

      <div class="inline-b mr8 mb16">
        <span class="label">合同号：</span>
        <Select :disabled="!contractInfo.roomId" v-model="contractInfo.contractCode" class="item-width" :label-in-value="true" @on-change="findContractInfo">
          <Option v-for="item in contractList" :value="item.contractNumber" :key="item.contractNumber">{{item.contractNumber}}</Option>
        </Select>
        <!-- <Input type="text" v-model="contractInfo.contractCode" class="item-width" @on-blur="findContractInfo"></Input> -->
      </div>
      <!-- <div class="inline-b mb16">
        <span class="label">房间号：</span>
        <Input :disabled="true" type="text" v-model="contractInfo.stockNumber" class="item-width"></Input>
      </div> -->
    </div>
    <div>
      <div class="inline-b mr8 mb16">
        <span class="label">客户名称：</span>
        <Input :disabled="true" type="text" v-model="contractInfo.customerName" class="item-width"></Input>
      </div>
      <div class="inline-b mr8 mb16">
        <span class="label">开始日期：</span>
        <DatePicker :disabled="true" class="item-width" v-model="contractInfo.conStartDate"  format="yyyy-MM-dd" placeholder="开始日期"></DatePicker>
      </div>
      <div class="inline-b mb16">
        <span class="label">结束日期：</span>
        <DatePicker :disabled="true" class="item-width" v-model="contractInfo.conEndDate"  format="yyyy-MM-dd" placeholder="结束日期"></DatePicker>
      </div>
    </div>
    <div>
      <div class="inline-b mr8 mb16">
        <span class="label">入住人：</span>
        <Input :disabled="true" type="text" v-model="contractInfo.checkName" class="item-width"></Input>
      </div>
    </div>
  </div>

  <div class="mt36" >
    <h4 class="title">账单信息</h4>
    <a href="javascript:;" @click="addFeeItem">添加收款</a>
    <div v-if="item.status" v-for="(item,i) in formList" class="flex">
      <fee-item :i="i" :ref="`feeItem${i}`" :n="clearKey" :feeItems = "feeItems" :roomId = "contractInfo.roomId" @inputPayment = "getTotalAmount"></fee-item>
      <Icon v-if="i!== 0" class="delete-icon" size="18" color="#F56356" type="android-remove-circle" @click.native="deleteItem(i)"></Icon>
    </div>
    <div>
      <Form :model="formData" :rules="formDataRules" ref="formData">
        <FormItem class="inline-b" :label-width="80" label="合计：" prop="oughtTotalAmount">
          <Input type="text" v-model="formData.oughtTotalAmount" :disabled="true" class="item-width">
            <span slot="append">元</span>
          </Input>
        </FormItem>
        <FormItem class="inline-b" :label-width="120" label="计划收款日期：" prop="planGatherDate">
          <DatePicker v-model="formData.planGatherDate" class="item-width" type="date" format="yyyy-MM-dd" @on-change="chanegPlanGatherDate" placeholder="计划收款日期"></DatePicker>
        </FormItem>
      </Form>
    </div>
  </div>


  <div  class="btn-wrap">
    <Button type="primary" size="large" @click="save" :disabled="!isCheckContract" :loading="loading">
      <span>提交</span>
    </Button>

    <Button type="primary" size="large" @click="save2" :disabled="!isCheckContract" :loading="loading2" v-if="status1List.length===1">
      <span>提交并收款</span>
    </Button>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { getProjects } from 'api/common'
import { fuzzyRoom } from 'api/functionalArea'
import { getContract } from 'api/archives'
import { getSubContractInfo, getReceivableCostItem, createBill } from 'api/accountsReceivable'
import FeeItem from './components/FeeItem';

export default {
  name:'creatbill',
  created(){
    this.initData()
  },
  data () {
    const validatePrice = (rule, value, callback)=>{
      const pattern = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
      if(pattern.test(value)){
        this.$emit('inputPayment')
        callback();
      }else {
        callback(new Error('输入正确的数字'));
      }
    }
    return {
      clearKey:0,
      isCheckContract:false,
      projectsList:[],
      remoteLoading:false,
      loading:false,
      loading2:false,

      contractInfo:{
        projectId:'',
        roomId:'',
        contractCode:'',
        // projectName:'',
        stockNumber:'',
        customerName:'',
        conStartDate:'',
        conEndDate:'',
        checkName:'',
      },
      formData:{
        oughtTotalAmount:'',
        planGatherDate:''
      },
      formDataRules:{
        oughtTotalAmount:[ { required:true, validator:validatePrice, trigger:'change' } ],
        planGatherDate:[{ required:true, message:'选择计划收款时间', trigger:'blur' } ]
      },
      roomList:[],
      contractList:[],
      // roomId:'',
      contractFid:'',
      feeItems:[],
      formList:[{
        index:0,
        status:1
      }]
    };
  },
  components:{
    FeeItem
  },
  computed:{
    status1List(){
      let ret=[]
      this.formList.forEach(ele=>{
        ele.status===1 && ret.push(ele)
      })
      return ret

    },
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    }
  },
  methods:{
    addFeeItem(){
      let len = this.formList.length
      this.formList.push({
        index:len,
        status:1
      })
    },
    clearValue(){
      this.clearKey ++
      this.formList = [{
        index:0,
        status:1
      }]
      this.$refs['formData'].resetFields();
      this.changeProject()
      this.contractInfo.projectId = this.projectsList[0].value
    },
    changeProject(val){
      this.roomList = []
      this.contractInfo.roomId = ''
      this.contractList = []
      this.contractInfo.contractCode = ''
      this.contractInfo.customerName=''
      this.contractInfo.conStartDate =  ''
      this.contractInfo.conEndDate = ''
      this.contractInfo.checkName = ''

    },
    changeRoomId(val){
      this.contractList = []
      this.contractFid = ''
      this.contractInfo.customerName=''
      this.contractInfo.conStartDate =  ''
      this.contractInfo.conEndDate = ''
      this.contractInfo.conEndDate = ''
      this.contractInfo.checkName = ''
      if(val){
        getContract({roomId:this.contractInfo.roomId}).then( res=> {
          this.contractList = res.data
        }).catch( (err)=> {
          console.log('error:当前房间没有有效合同')
        })
      }
    },

    chanegPlanGatherDate(val){
      this.formData.planGatherDate = val
    },
    closeTag(){
      this.clearValue()
      // this.$router.push({ name: 'accountsreceivable'})
      this.$routerGo({name: 'accountsreceivable'})
    },

    deleteItem(i){
      this.formList[i].status = 0
      this.getTotalAmount()
    },
    findContractInfo(data){
      this.isCheckContract = false
      if(data.label){
        getSubContractInfo(data.label).then(res => {
          // this.contractInfo.projectName = res.data.projectName
          // this.contractInfo.stockNumber = res.data.stockNumber
          this.contractInfo.customerName = res.data.customerName
          this.contractInfo.conStartDate = res.data.conStartDate
          this.contractInfo.conEndDate = res.data.conEndDate
          this.contractInfo.checkName = res.data.checkName
          // this.roomId = res.data.stockFid
          this.contractFid = res.data.contractFid
          this.isCheckContract = true
        })
      }
    },
    getTotalAmount(){
      let list = this.formList.filter( item => {
        return item.status === 1
      })
      let total = list.reduce((sum,cur,i) => {
        let oughtAmount = +this.$refs[`feeItem${cur.index}`][0].feeItem.oughtAmount
        if(oughtAmount) {
          return  sum + oughtAmount
        } else {
          return sum
        }
      },0)
      this.formData.oughtTotalAmount = total.toFixed(2)
    },
    initData(){
      getProjects().then( res => {
        this.projectsList = res.data
        this.contractInfo.projectId = this.projectsList[0].value
      })
      getReceivableCostItem().then( res => {
        this.feeItems = res.data.costCodeEnum
      })
    },
    remoteMethod(query){
      if (query !== '' && this.contractInfo.projectId !=='') {
        this.remoteLoading = true;
        let params = {
          projectid:this.contractInfo.projectId,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.remoteLoading = false;
          this.roomList = res.data;
        })
      } else {
          this.roomList = [];
          this.contractInfo.roomId = ''
      }
    },
    save2(){
      let receivableBillDetail = this.validateCollections()
      if(!this.contractFid){
        this.$Message.info('请选择有效的合同！')
        return
      }
      if(receivableBillDetail){
        this.$refs.formData.validate( bool=>{
          if(bool){
            let data = {
              receivableBillDetailParamDtos: receivableBillDetail,
              receivableBillParamDto: {
                contractFid:this.contractFid,
                oughtTotalAmount: this.formData.oughtTotalAmount,
                planGatherDate:this.formData.planGatherDate,
              }
            }
            //新建账单
            this.loading2 = true

            createBill(data).then( res => {
              this.$Message.success('新建账单成功')
              this.$router.push({
                name: 'collection',
                query:{
                  proId:this.contractInfo.projectId,
                  bNum: res.data.join(','),
                  cCode: this.contractInfo.contractCode
                }
              })
              // this.closeTag()
              // this.$router.push({name: 'accountsreceivable'})
            }).finally ( () => {
              this.loading2 = false
            })
          }
        })
      }

    },
    save(){
      let receivableBillDetail = this.validateCollections()
      if(!this.contractFid){
         this.$Message.info('请选择有效的合同！')
         return
      }
      if(receivableBillDetail){
        this.$refs.formData.validate( bool=>{
          if(bool){
            let data = {
              receivableBillDetailParamDtos: receivableBillDetail,
              receivableBillParamDto: {
                contractFid:this.contractFid,
                oughtTotalAmount: this.formData.oughtTotalAmount,
                planGatherDate:this.formData.planGatherDate,
              }
            }
            //新建账单
            this.loading = true

            createBill(data).then( res => {
              this.$Message.success('新建账单成功')
              this.closeTag()
              // this.$router.push({name: 'accountsreceivable'})
            }).finally ( () => {
              this.loading = false
            })
          }
        })
      }
    },
    showImg(img){
      this.imgSrc =img
      this.showImgKey++
    },
    validateCollections(){
      let list = this.formList.filter( item => {
        return item.status === 1
      })
      let feeList = []
      let result = list.every( item => {
        feeList.push(this.$refs[`feeItem${item.index}`][0].formValidate())
        return this.$refs[`feeItem${item.index}`][0].formValidate()
      })

      if(result) {
        // 费用项是否唯一
        let isOnly = feeList.every((item,i,arr)=> {
          let findIndex =  arr.findIndex( ele => {
            return ele.expenseItemId ===  item.expenseItemId
          })
          return findIndex === i
        })
        if(!isOnly){
          this.$Message.info('存在重复的费用项，请重新选择！')
        }
       return isOnly ? feeList : false
      }else{
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>

.label {
  width: 80px;
  display: inline-block;
  text-align: right;
}
.btn-wrap {
width: 100%;
text-align: center;
}
.flex {
  display: flex;
}

</style>
